/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

function debounce(fn, delay) {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
}

function equalizeH3Heights() {
  const headings = document.querySelectorAll('.product-slider-item .content h3');
  if (!headings.length) return;
  let maxHeight = 0;
  headings.forEach(h3 => {
    h3.style.height = 'auto';
    if (h3.offsetHeight > maxHeight) {
      maxHeight = h3.offsetHeight;
    }
  });
  headings.forEach(h3 => {
    h3.style.height = `${maxHeight}px`;
  });
}

function EqualGridTitleHeight() {
  const HeadingTitle = document.querySelectorAll('.custom-icons__row .icons-row-item .icons-row-item__wrapper .icons-row-item__content .icons-row-item__title');
  if (!HeadingTitle.length) return;
  let maxHeight = 0;
  HeadingTitle.forEach(h3 => {
    h3.style.height = 'auto';
    if (h3.offsetHeight > maxHeight) {
      maxHeight = h3.offsetHeight;
    }
  });
  HeadingTitle.forEach(h3 => {
    h3.style.height = `${maxHeight}px`;
  });
}

const debouncedEqualizeH3 = debounce(equalizeH3Heights, 150);
const debouncedEqualGridTitle = debounce(EqualGridTitleHeight, 150);

/**
 * Sort cm-based Größe / Size option pills (and dropdown items) ascending
 * by the first dimension number, then preselect the first (smallest).
 * Letter sizes (S/M/L) are left alone.
 */
const CM_SIZE_OPTION_HANDLES = ['grosse', 'size'];
const CM_SIZE_FIRST_NUMBER = /^(\d+)/;
const CM_SIZE_SORTED_ATTR = 'data-cm-size-sorted';

function getCmSizeSortKey(value) {
  if (!value) return Number.POSITIVE_INFINITY;
  const match = String(value).trim().match(CM_SIZE_FIRST_NUMBER);
  return match ? parseInt(match[1], 10) : Number.POSITIVE_INFINITY;
}

function valuesContainCm(values) {
  return values.some((value) => String(value).toLowerCase().includes('cm'));
}

function sortNodesByCmSize(nodes, getValue) {
  const list = Array.from(nodes);
  if (list.length < 2) return false;

  const values = list.map(getValue);
  if (!valuesContainCm(values)) return false;

  list
    .sort((a, b) => getCmSizeSortKey(getValue(a)) - getCmSizeSortKey(getValue(b)))
    .forEach((node) => node.parentNode.appendChild(node));

  return true;
}

function getRadioOptionValue(button) {
  const input = button.querySelector('input[data-single-option-selector], input.radio__input, input.swatch__input');
  if (input && input.value) return input.value;
  const title = button.querySelector('.option-title');
  return title ? title.textContent.trim() : '';
}

function getPopoutOptionValue(item) {
  const option = item.querySelector('[data-popout-option]');
  if (option && option.dataset.value) return option.dataset.value;
  return item.textContent.trim();
}

function preselectFirstRadioOption(container) {
  const firstButton = container.querySelector('.radio__button, .swatch__button');
  if (!firstButton) return;

  const input = firstButton.querySelector('input[data-single-option-selector], input.radio__input, input.swatch__input');
  if (!input) return;

  const value = input.value;
  if (!input.checked) {
    input.checked = true;
  }

  const selectedLabel = container.closest('fieldset')?.querySelector('.radio__legend .selected-value');
  if (selectedLabel) selectedLabel.textContent = value;

  // Defer so ProductForm listeners from theme.js are ready
  requestAnimationFrame(() => {
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}

function preselectFirstPopoutOption(list) {
  const firstItem = list.querySelector(':scope > .select-popout__item');
  if (!firstItem) return;

  const option = firstItem.querySelector('[data-popout-option]');
  if (!option) return;

  const popout = list.closest('popout-select');
  const hiddenInput = popout?.querySelector('[data-popout-input]');
  const textEl = popout?.querySelector('[data-popout-text]');
  const value = option.dataset.value || option.textContent.trim();

  list.querySelectorAll('.select-popout__item--current').forEach((item) => {
    item.classList.remove('select-popout__item--current');
    item.querySelector('[data-popout-option]')?.removeAttribute('aria-current');
  });

  firstItem.classList.add('select-popout__item--current');
  option.setAttribute('aria-current', 'true');

  if (textEl) textEl.textContent = value;
  if (hiddenInput && hiddenInput.value !== value) {
    hiddenInput.value = value;
    hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

function sortCmSizeRadioButtons(root = document) {
  CM_SIZE_OPTION_HANDLES.forEach((handle) => {
    root.querySelectorAll(`fieldset[data-option="${handle}"]`).forEach((fieldset) => {
      const container = fieldset.querySelector('[data-variant-buttons]');
      if (!container || container.hasAttribute(CM_SIZE_SORTED_ATTR)) return;

      const sorted = sortNodesByCmSize(container.children, getRadioOptionValue);
      if (!sorted) return;

      container.setAttribute(CM_SIZE_SORTED_ATTR, '');
      preselectFirstRadioOption(container);
    });
  });
}

function sortCmSizePopoutLists(root = document) {
  CM_SIZE_OPTION_HANDLES.forEach((handle) => {
    root.querySelectorAll(`[id$="-select-${handle}"] .select-popout__list__scroll`).forEach((list) => {
      if (list.hasAttribute(CM_SIZE_SORTED_ATTR)) return;

      const sorted = sortNodesByCmSize(list.querySelectorAll(':scope > .select-popout__item'), getPopoutOptionValue);
      if (!sorted) return;

      list.setAttribute(CM_SIZE_SORTED_ATTR, '');
      preselectFirstPopoutOption(list);
    });
  });
}

function sortCmSizeOptions(root = document) {
  sortCmSizeRadioButtons(root);
  sortCmSizePopoutLists(root);
}

function initCmSizeOptionSorting() {
  sortCmSizeOptions(document);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (
          node.matches?.('fieldset[data-option], [data-variant-buttons], .select-popout__list, [data-quick-view-item], .popup-quick-view') ||
          node.querySelector?.('fieldset[data-option], [data-variant-buttons], .select-popout__list__scroll')
        ) {
          sortCmSizeOptions(node);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    requestAnimationFrame(equalizeH3Heights);
    requestAnimationFrame(EqualGridTitleHeight);
    initCmSizeOptionSorting();
  });
} else {
  requestAnimationFrame(equalizeH3Heights);
  requestAnimationFrame(EqualGridTitleHeight);
  initCmSizeOptionSorting();
}
window.addEventListener('resize', debouncedEqualizeH3, { passive: true });
window.addEventListener('resize', debouncedEqualGridTitle, { passive: true });


